import React, { useState } from "react";

const ChildCardInfo = ({ onAdd }) => {
  const [childCardName, setChildCardName] = useState("");
  const [reportId, setReportId] = useState("");
  const [groupId, setGroupId] = useState("");
  const [status, setStatus] = useState(""); 

  const handleAdd = () => {
    if (childCardName && reportId && groupId) {
      onAdd({ childCardName, reportId, groupId, status });
      setChildCardName("");
      setReportId("");
      setGroupId("");
      setStatus(""); 
    }
  };

  return (
    <div className="w-full space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-700">
            Child Card Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            required
            placeholder="Enter Child Card Name"
            value={childCardName}
            onChange={(e) => setChildCardName(e.target.value)}
            className="px-4 py-2 w-full border rounded-md shadow-sm focus:ring focus:ring-green-400"
          />
        </div>
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-700">
            Report ID <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter Report ID"
            required
            value={reportId}
            onChange={(e) => setReportId(e.target.value)}
            className="px-4 py-2 w-full border rounded-md shadow-sm focus:ring focus:ring-green-400"
          />
        </div>
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-700">
            Group ID <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            required
            placeholder="Enter Group ID"
            value={groupId}
            onChange={(e) => setGroupId(e.target.value)}
            className="px-4 py-2 w-full border rounded-md shadow-sm focus:ring focus:ring-green-400"
          />
        </div>
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-700">
            Status <span className="text-xs font-light text-red-500">(if report not available)</span>
          </label>
          <input
            type="text"
            placeholder="Enter Status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="px-4 py-2 w-full border rounded-md shadow-sm focus:ring focus:ring-green-400"
          />
        </div>
      </div>
      <button
        onClick={handleAdd}
        className="px-6 py-2 bg-green-500 text-white font-semibold rounded-md hover:bg-green-600 transition"
      >
        Add Child Info
      </button>
    </div>
  );
};

export default ChildCardInfo;
